import TSvgProps from 'svgIcons/type/svgPropsType'

const ChatIcon = (props: TSvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
    >
      <desc>실시간 채팅 아이콘</desc>
      <defs>
        <clipPath id="xrqmtcpgca">
          <path
            fill="#fff"
            stroke="#707070"
            strokeWidth="1.2"
            d="M-.371 0h20v20h-20z"
            data-name="사각형 34506"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath="url(#xrqmtcpgca)"
        data-name="icon / 20 / chat"
        transform="translate(.371)"
      >
        <g data-name="그룹 50542">
          <g data-name="그룹 50539">
            <g data-name="그룹 50538">
              <g fill="#d4d4d4" data-name="합치기 389">
                <path d="M8.584 14.776a5.8 5.8 0 0 1-3.65-1.273l-.218-.174-.273.055-1.076.214a.4.4 0 0 1-.393-.145.4.4 0 0 1-.074-.34l.345-1.466.046-.196-.08-.183a5.872 5.872 0 0 1 5.373-8.222 5.87 5.87 0 0 1 5.865 5.866 5.87 5.87 0 0 1-5.865 5.864"></path>
                <path d="M8.584 14.176a5.27 5.27 0 0 0 5.265-5.264 5.27 5.27 0 0 0-5.265-5.266 5.272 5.272 0 0 0-4.824 7.38l.161.368-.366 1.555 1.317-.262.435.346a5.2 5.2 0 0 0 3.277 1.143m0 1.2a6.44 6.44 0 0 1-4.024-1.404l-1.076.215a1 1 0 0 1-1.168-1.211l.345-1.467a6.466 6.466 0 1 1 5.922 3.867z"></path>
              </g>
              <path
                fill="#ddd"
                d="M11.41 5.525a5.956 5.956 0 0 1 6.079 5.825 5.956 5.956 0 0 1-6.079 5.825 5.956 5.956 0 0 1-6.079-5.825 5.956 5.956 0 0 1 6.079-5.825"
                data-name="합치기 390"
              ></path>
            </g>
          </g>
          <g data-name="그룹 50541">
            <g data-name="그룹 50540">
              <g fill="#ffbb01" data-name="합치기 391">
                <path d="M11.122 17.239a5.87 5.87 0 0 1-5.866-5.864 5.87 5.87 0 0 1 5.866-5.866 5.87 5.87 0 0 1 5.865 5.866 5.86 5.86 0 0 1-.793 2.947l-.127.217.066.243.38 1.39a.4.4 0 0 1-.068.347.39.39 0 0 1-.381.152l-1.65-.268-.208-.034-.185.105c-.879.5-1.881.765-2.9.765z"></path>
                <path d="M11.122 16.639c.914 0 1.814-.237 2.602-.686l.369-.21 1.759.286-.43-1.574.253-.435a5.26 5.26 0 0 0 .712-2.645 5.27 5.27 0 0 0-5.265-5.266 5.27 5.27 0 0 0-5.266 5.266 5.27 5.27 0 0 0 5.266 5.264m0 1.2a6.466 6.466 0 1 1 5.59-3.215l.38 1.39a1 1 0 0 1-1.126 1.25l-1.648-.269a6.44 6.44 0 0 1-3.196.844"></path>
              </g>
            </g>
            <path
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.2"
              d="M8.351 10.522h5.542"
              data-name="선 2126"
            ></path>
            <path
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeWidth="1.2"
              d="M8.351 12.369h3.695"
              data-name="선 2127"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ChatIcon
